module.exports = __webpack_public_path__ + "img/fangAn.4b679074.png";